import { migrationContext } from '../../migrationUsersBranchView.poeditor';

export const migrationLeaveModalKeys = {
  title: `${migrationContext}-mbMigrationModalTitleRejectMigration`,
  description: `${migrationContext}-mbMigrationModalDescriptionRejectMigration`,
  cancelLink: `${migrationContext}-mbMigrationModalCancelProductsAndNotMigrateLink`,
  continueButton: `${migrationContext}-mbMigrationModalMigrateAndEnjoyProductsButton`,
  titleLeave: `${migrationContext}-mbMigrationModalLeaveTheProcessTitle`,
  descriptionLeave: `${migrationContext}-mbMigrationModalLeaveTheProcessDescription`,
  buttonRightLeave: `${migrationContext}-mbMigrationModalLeaveTheProcessYesExitButton`,
  buttonLeftLeave: `${migrationContext}-mbMigrationModalLeaveTheProcessNoButton`,
};
